import { Directive, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Guid } from '@lsq-frontend/remote-services/enterprise/common';
import { LsqImagePreviewComponent } from '@lsq-frontend/common-ui';

@Directive()
export abstract class BaseImagePreviewComponent implements OnInit, OnChanges {
    @Input() public imageId: Guid;
    /**
     * Pass an array of imageIds if you want to display multiple images as if they were pages
     * (as opposed to, for example, a multipage TIF, which is a single image file with multiple pages)
     */
    @Input() public imageIds?: Guid[];
    @Input() public imageUrl: string;
    @Input() public downloadUrl: string;
    @Input() public filename?: string;
    @Input() public totalPages?: number;
    @ViewChild('imagePreviewElement') public imagePreviewElement: LsqImagePreviewComponent;

    public currentPage = 1;
    public activeImageId: Guid;
    public imagePageArray?: number[];

    public abstract getImageUrl(): Promise<void>;

    public ngOnInit(): void {
        if (!this.totalPages) {
            if (this._isMultiImage) {
                this.totalPages = this.imageIds.length;
            } else {
                this.totalPages = 1;
            }
        }
        if (!!this.imageId) {
            this.activeImageId = this.imageId;
        } else if (!!this.imageIds && !!this.imageIds.length) {
            this.activeImageId = this.imageIds[0];
        }

        if (!this.imageUrl) {
            this.getImageUrl();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!!this.imageUrl && changes.imageId && changes.imageId.currentValue) {
            this.imagePreviewElement.reset();
            this.currentPage = 1;
            this.getImageUrl();
        }
    }

    public handlePageChange(pageNumber: number): void {
        this.currentPage = pageNumber;
    }

    protected get _isMultiImage(): boolean {
        return !this.imageId && !!this.imageIds && !!this.imageIds.length;
    }
}
